var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[(_vm.documentController.file)?_c('document-viewer',_vm._g({attrs:{"value":_vm.value,"view":_vm.view,"canEdit":false,"mode":_vm.mode ? _vm.mode : 'view',"selectedTag":_vm.selectedTag}},_vm.$listeners)):_c('p-content-placeholder',{attrs:{"image":require('../background_empty.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }